import React, {Component} from "react";
import ProductionTitleBar from "./ProductionTitleBar";
import "./ProductionCompletionList.css";
import ProductionTable from "./ProductionTable";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../configuration";
import axios from "axios";

class ProductionCompletionList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            items: [],
            totalItemCount: 0,
            activePage: 1,
            searchData : {
                searchText : null,
                offset : 0,
                limit : 5
            }
        };
        this.getFilteredProducts = this.getFilteredProducts.bind(this);
        this.getAllProduction = this.getAllProduction.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    setSearchText = (event) => {
       this.getFilteredProducts(event.target.value)
    };

    getFilteredProducts = (searchData) => {
        if (searchData===''){
            this.getAllProduction(0,5);
        }else {
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };
            axios.get(RESOURCE_BASE_URL + 'api/orders/inwarehouse/search/generated/' + searchData + '?offset=0&limit=10', axiosConfig)
                .then((res) => {
                    // console.log("FILTERED INQUIRIES ==== > ", res.data);
                    this.setState({
                        items: res.data.items,
                        totalItemCount: res.data.rowCount
                    })
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
    };

    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;
        // this.getAllProduction(pageNumber - 1, 3);
        this.getAllProduction(pageNumber - 1, ITEM_COUNT_PER_PAGE);
    };

    componentDidMount() {
        this.getAllProduction(0,5);
    }

    getAllProduction = (offset, limit) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/orders/items/inwarehouse?offset=' + offset + '&limit=' + limit, axiosConfig)
            .then((res) => {
                this.setState({
                    items: res.data.items,
                    totalItemCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    render() {
        return (
            <div className="admin-inquiry-content">
                <div className="admin-inquiry-div" id="production-outer-div">
                    <ProductionTitleBar setSearchText={this.setSearchText}
                                        totalItemCount={this.state.totalItemCount}/>
                    <ProductionTable handlePageChange={this.handlePageChange}
                                     activePage={this.state.activePage}
                                     totalItemCount={this.state.totalItemCount}
                                     items={this.state.items}
                                     getAll = {this.getFilteredProducts}
                                     getAllProduction = {this.getAllProduction}
                    />
                </div>
            </div>
        );
    }
}
export default ProductionCompletionList;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ProductionCompletionList.js